import React from 'react';
import { ArticleHeading3, InformationTooltip, UIText2, ArticleHeading4 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { ConditionalWrapper } from '@cian/conditional-component';
import { PskTooltipContent } from './components/PskTooltipContent';
import { transformNumToString } from 'shared/utils/common';
import { PERCENT } from 'shared/constants/common';
import styles from './styles.css';
import { IPsk } from 'shared/types/common/offer';
import { useIsDesktop } from '../../../../hooks/common';

export interface IPskBlockProps extends IPsk {}

export const PskBlock: React.FC<IPskBlockProps> = ({ from, to }) => {
  const isDesktop = useIsDesktop();

  return (
    <div role="button" onClick={e => e.stopPropagation()} className={styles['container']}>
      <InformationTooltip
        placement={'right-start'}
        content={<PskTooltipContent />}
        header={'Полная стоимость кредита'}
        portal={true}
      >
        <div>
          <div className={styles['title']}>
            <UIText2 color={'current_color'}>Полная стоимость кредита</UIText2>
            <div className={styles['tooltip']}>
              <IconFunctionalInformationCircle16 color={'icon-secondary-default'} cursor="pointer" />
            </div>
          </div>
          <div className={styles['description']}>
            <ConditionalWrapper
              if={isDesktop}
              ThenComponent={({ children }) => <ArticleHeading4 color={'current_color'}>{children}</ArticleHeading4>}
              ElseComponent={({ children }) => <ArticleHeading3 color={'current_color'}>{children}</ArticleHeading3>}
            >
              {transformNumToString(+from) + '—' + transformNumToString(+to) + PERCENT}
            </ConditionalWrapper>
          </div>
        </div>
      </InformationTooltip>
    </div>
  );
};
